import { Address } from 'viem';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

export interface SwapFeeStore {
  swapFeeBps: number | undefined;
  swapFeeRecipient: Address | undefined;
  swapFeeToken: Address | undefined;
  setSwapFeeBps: (swapFeeBps: number | undefined) => void;
  setSwapFeeRecipient: (swapFeeRecipient: Address | undefined) => void;
  setSwapFeeToken: (swapFeeToken: Address | undefined) => void;
}

export const useSwapFeeStore = createWithEqualityFn<SwapFeeStore>()(
  (set, get) => ({
    swapFeeBps: undefined,
    swapFeeRecipient: undefined,
    swapFeeToken: undefined,
    setSwapFeeBps: (swapFeeBps: number | undefined) =>
      set({
        swapFeeBps,
      }),
    setSwapFeeRecipient: (swapFeeRecipient: Address | undefined) =>
      set({
        swapFeeRecipient,
      }),
    setSwapFeeToken: (swapFeeToken: Address | undefined) =>
      set({
        swapFeeToken,
      }),
  }),
  shallow,
);
